/**
 * Find the control id of the product tree from contrl def
 * @param {Array} controlDefs - list of control definitions for a panel
 * @returns {Number} product tree control id
 */

import { storeInstance } from "../store";

export default () => {
    let result =  storeInstance.state.panel_control_defs.find((def) => def.classSystem === "propSystemKb")
    if (result) {
        return result?.id
    }
    return;
};
